import { Button, Dialog, DialogContent, TextField } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useState } from "react";
import { useSnackbar } from 'notistack';
import transfer_icon from 'assets/img/transfer_icon.svg'
import { ApiRequest } from 'GlobalFunctions';


export default function TransferStoreSection() {
    const [open, setOpen] = useState(false);
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();


    const submitTransfer = () => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            enqueueSnackbar('Please enter a valid email address.', { variant: 'error' });
            return;
        }

        setLoading(true);
        ApiRequest({
            url: '/stores/initStoreTransfer',
            method: 'POST',
            body: {
                email: email
            },
            setResponse: (response: any) => {
                setLoading(false);
                if (response.status === "success") {
                    enqueueSnackbar(
                        <div className="snackbar_notification">
                            <span className="snackbar_title">Store Transfer Initiated</span>
                            <span className="snackbar_message">An invitation has been sent to {email} to accept ownership of the store.</span>
                        </div>,
                        { 
                            variant: 'default',
                            className: 'pc-notification-success'
                        }
                    );
                    setOpen(false);
                    setEmail('');
                    window.location.reload();
                } else {
                    enqueueSnackbar('Failed to initiate store transfer', { variant: 'error' });
                }
            }
        });
    }


    return (
        <>
            <h3 className="heading_h3">Transfer Store</h3>
            <p className="subheading">Transfer your store to a new owner to manage</p>
            <Button
                variant="outlined"
                color="primary"
                style={{ marginTop: '10px' }}
                onClick={() => setOpen(true)}
                sx={{
                    borderColor: '#B9B9B9',
                    borderRadius: '5px !important',
                    color: '#424242',
                    padding: '6px 10px !important',
                    '&:hover': {
                        backgroundColor: 'transparent',
                        borderColor: '#B9B9B9',
                        color: '#424242'
                    }
                }}
            >
                Transfer Store
            </Button>


            <Dialog
                open={open}
                onClose={() => setOpen(false)}
            >
                <DialogContent style={{ padding: '27px', maxWidth: '530px' }}>
                    <div className="transfer_dialog_header">
                        <img src={transfer_icon} alt="Transfer Icon" />
                        <h3 className='heading_h3_dialog'>Transfer Site</h3>
                    </div>
                    <div className="dialog_text">
                        <p>Transferring this store will unpublish the site and remove all connected domains.  Any custom integrations or automations may need to be reconfigured after transfer.</p>
                        <p>Once the transfer is accepted, you will no longer have access to this store or its settings.</p>
                        <p>To complete the transfer, enter the recipient’s email address below. They’ll receive instructions to accept the transfer and reactivate billing.</p>
                    </div>
                    <label className="dialog_label">Email
                    <TextField
                        name="email"
                        fullWidth
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        style={{ paddingTop:'5px',marginBottom: '15px' }}
                    />
                    </label>


                    <div className="transfer_dialog_actions">
                        <Button
                            variant="text"
                            color="primary"
                            onClick={() => { setOpen(false); setEmail(''); }}
                            sx={{
                                borderColor: '#B9B9B9',
                                borderRadius: '5px !important',
                                color: '#424242',
                                padding: '6px 10px !important',
                                marginRight: '10px',
                                '&:hover': {
                                    backgroundColor: 'transparent',
                                    borderColor: '#B9B9B9',
                                    color: '#424242'
                                }
                            }}
                        >
                            Cancel
                        </Button>
                        <LoadingButton
                            variant="contained"
                            color="primary"
                            onClick={submitTransfer}
                            loading={loading}
                            sx={{
                                borderRadius: '5px !important',
                                padding: '6px 10px !important',
                                backgroundColor: '#BD2B2B',
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: '#BD2B2B'
                                }
                            }}
                        >
                            Transfer
                        </LoadingButton>
                    </div>
                </DialogContent>


            </Dialog>
        </>
    )
}